import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import _ from "lodash";
import { onMounted, withDefaults, ref, provide } from "vue";
import Tippy, { ProvideTippy } from "@/base-components/Tippy";
import { PopperElement } from "tippy.js";

interface SideMenuTooltipProps {
  refKey?: string;
  as?: string | object;
  content: string;
  position: string;
}

// @ts-ignore

export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenuTooltip',
  props: {
    refKey: null,
    as: { default: "a" },
    content: null,
    position: null
  },
  setup(__props: any) {

const props = __props as { refKey?: string, as: string | object, content: string, position: string }

const toggleTooltip = (el: PopperElement) => {
  if (window.innerWidth <= 1260) {
    el._tippy?.enable();
  } else {
    el._tippy?.disable();
  }
};

// @ts-ignore
const initTooltipEvent = (tippyRef: PopperElement) => {
  window.addEventListener("resize", () => {
    if (props.position === "side") {
      toggleTooltip(tippyRef);
    }
  });
};

// @ts-ignore


// @ts-ignore
const tippyRef = ref<PopperElement>();

// @ts-ignore
provide<ProvideTippy>("bind[sideMenuTooltipRef]", (el) => {
  tippyRef.value = el;
});

onMounted(() => {
  if (tippyRef.value) {
    if (props.position === "side") {
      toggleTooltip(tippyRef.value);
    }
    initTooltipEvent(tippyRef.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tippy), {
    as: props.as,
    content: props.content,
    options: {
      placement: 'left',
    },
    refKey: "sideMenuTooltipRef"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as", "content"]))
}
}

})